import {StyleSheet} from "aphrodite";

import {border, semanticColor, sizing} from "@khanacademy/wonder-blocks-tokens";

import {
    PADDING_TO_REVEAL_BORDER,
    PREVIEW_HEIGHT,
    PREVIEW_WIDTH,
} from "./constants.ts";

export const sharedStyles = StyleSheet.create({
    content: {
        inlineSize: "100%",
        minInlineSize: PREVIEW_WIDTH + PADDING_TO_REVEAL_BORDER,
        height: PREVIEW_HEIGHT + PADDING_TO_REVEAL_BORDER,
        minBlockSize: PREVIEW_HEIGHT + PADDING_TO_REVEAL_BORDER,
    },
    previewContainer: {
        inlineSize: "100%",
        minInlineSize: PREVIEW_WIDTH + PADDING_TO_REVEAL_BORDER,
        height: PREVIEW_HEIGHT + PADDING_TO_REVEAL_BORDER,
        minBlockSize: PREVIEW_HEIGHT + PADDING_TO_REVEAL_BORDER,
        alignItems: "center",
        justifyContent: "center",
        border: `${border.width.thin} dashed ${semanticColor.core.border.neutral.default}`,
        borderRadius: border.radius.radius_080,
        gap: sizing.size_200,
    },
    imageFilenameContainer: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "#F7F8FA",
        padding: sizing.size_160,
        borderRadius: border.radius.radius_080,
        inlineSize: "100%",
    },
    imageFilenameRow: {
        flexDirection: "row",
        alignItems: "center",
        gap: sizing.size_160,
    },
    imageFilenameOverflow: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
});
